import { connectTable } from 'custom-table/js/components/DefaultTable/container'
import LadderTable from '.'

export default connectTable(LadderTable);
